import { Button as ButtonComponent, ButtonProps } from "@heroui/react";
import React from "react";
import { cn } from "@/lib/utils";

type HeroUISize = "sm" | "md" | "lg";
type ButtonSize = "xs" | HeroUISize;

interface CustomButtonProps extends Omit<ButtonProps, "size"> {
    size?: ButtonSize;
    children?: React.ReactNode;
}

export const Button = ({ children, size = "md", ...props }: CustomButtonProps) => {
    const color = props.color ? props.color : 'primary';
    const variant = props.variant ? props.variant : 'solid';
    const isIconOnly = props.isIconOnly ? props.isIconOnly : false;

    let sizeClasses = "";
    let heroUiSize: HeroUISize | undefined = undefined;

    if (size === "xs") {
        sizeClasses = "h-6 w-6 p-0 m-0 min-w-0 text-background";
    } else {
        heroUiSize = size;
    }

    return (
        <ButtonComponent
            {...props}
            className={cn(
                isIconOnly && "border-none",
                (color === 'primary' && variant === 'solid') && "text-background dark:text-foreground bg-gradient-to-t from-primary-700 to-primary-500 dark:from-primary-800 dark:to-primary-600",
                (variant === 'light' && !isIconOnly) && "bg-gradient-to-t from-light-400 to-light-900 dark:from-light-200 dark:to-light-300",
                props.className,
                sizeClasses,
            )}
            shadow="none"
            radius="lg"
            size={heroUiSize}
        >
            {children}
        </ButtonComponent>
    );
};